export default (url: string): boolean =>
    typeof url === 'string' && url.slice(0, 7) === 'mailto:'
